<template>
<div class="card float-e-margins">
  <div class="card-title">
    <h1>
      Heb je nog een vraag? Laat het mij weten!
    </h1>
    <h3>
      Dan krijg je binnen 24 uur een antwoord terug van mij.
    </h3>
  </div>
  <div class="card-content no-padding">
    <div class="row">
      <form class="form-horizontal" name="contact-form" v-on:submit.prevent="SubmitForm">
        <div class="form-group">
          <label for="name" class="col-sm-1 control-label">Naam</label>
          <div class="col-sm-8">
            <input type="text" v-model="customer.Name" class="form-control" id="name" name="name" placeholder="Voor- en Achternaam" required>
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-sm-1 control-label">Email</label>
          <div class="col-sm-8">
            <input type="email" v-model="customer.Email" class="form-control" id="email" name="email" placeholder="voorbeeld@email.nl" required>
          </div>
        </div>
        <div class="form-group">
          <label for="message" class="col-sm-1 control-label">Bericht</label>
          <div class="col-sm-8">
            <textarea class="form-control" v-model="customer.Content" rows="4" name="message" required></textarea>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-4 col-sm-offset-8">
            <input id="submit" id="sendButton" name="submit" type="submit" value="Verzend" class="btn btn-primary">
          </div>
        </div>
        <!-- after save start -->
        <vc-alert v-if="success" type="success" :dismissible="false">
          Contactformulier succesvol verzonden!
        </vc-alert>
        <vc-alert v-if="error" type="danger" :dismissible="false">
           {{errorMessage}}
        </vc-alert>
        <!-- after save end -->
      </form>
    </div> 
  </div>
</div>
</template>

<style scoped>
.form-horizontal .control-label{
  /* text-align:right; */
  text-align:left;
  margin-left: 15px;
}
</style>

<script>
import callbackalert from './Common/CallbackAlert'
import store from '../store'

export default {
  components: {
    'vc-alert': callbackalert,
    store: store
  },
  data () {
    return {
      customer: {},
      error: false,
      success: false,
      isValid: true
    }
  },
  methods: {
    onVerify: function (response) {
      this.error = false
      this.isValid = true
      console.log('Verify: ' + response)
    },
    onExpired: function () {
      console.log('reCAPTHA Expired')
    },
    SubmitForm: function () {
      if (!this.isValid) {
        this.error = true
        this.errorMessage = 'Valideer je gegevens!'
      } else {
        $.ajax({
          type: 'POST',
          url: store.root + 'api/Contact',
          data: this.customer,
          xhrFields: {
            withCredentials: true
          }
        }).done(function () {
          this.success = true
          this.error = false
          this.customer = {}
          document.getElementById('sendButton').disabled = true
        }.bind(this))
        .fail(function (response) {
          console.log(response)
          this.success = false
          this.error = true
          this.errorMessage = 'Er is een fout opgetreden, probeer later opnieuw!'
        }.bind(this))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Contact.vue?0280a949